export interface fakeDataType {
  account: string
  username: string
  token: string
}

export const fakeData = {
  account: 'admin',
  username: '測試用使用者',
  token: '@test!admin'
}